import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdAnnotationsOptions } from '@onefootprint/fetch-dashboard';
import { IcoArrowDown16, IcoPin16 } from '@onefootprint/icons';
import { Divider } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { cx } from 'class-variance-authority';
import { useQueryState } from 'nuqs';
import { Fragment, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHover } from 'usehooks-ts';
import useEntityId from '@/entity/hooks/use-entity-id';
import PinnedNote from './components/pinned-note';
const PinnedNotes = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pinnedNotes"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const entityId = useEntityId();
  let t1;
  if ($[1] !== entityId) {
    t1 = getEntitiesByFpIdAnnotationsOptions({
      path: {
        fpId: entityId
      }
    });
    $[1] = entityId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1,
      select: _temp2
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const annotationsQuery = useQuery(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      defaultValue: "descending",
      history: "push"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [sortDirection, setSortDirection] = useQueryState("sortDirection", t3);
  let t4;
  if ($[6] !== sortDirection) {
    t4 = (a, b) => sortDirection === "descending" ? sortDescending(a, b) : sortAscending(a, b);
    $[6] = sortDirection;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const data_0 = [...(annotationsQuery.data ?? [])].sort(t4);
  const sortButtonRef = useRef(null);
  const isHover = useHover(sortButtonRef as React.RefObject<HTMLElement>);
  let t5;
  if ($[8] !== setSortDirection) {
    t5 = () => {
      setSortDirection(_temp3);
    };
    $[8] = setSortDirection;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleSortData = t5;
  return data_0.length > 0 ? <div className="mt-6"><div className="flex items-center justify-between gap-1"><div className="flex items-center gap-1 mb-3"><IcoPin16 /><p className="text-label-2">{t(_temp4)}</p></div>{data_0.length > 1 ? <button className={cx("flex flex-row items-center justify-center gap-3", "cursor-pointer select-none", "transition-colors duration-200 ease-in-out", "text-tertiary hover:text-primary text-label-2", "group")} onClick={handleSortData} ref={sortButtonRef} type="button"><div className="flex items-center justify-center gap-2">{sortDirection === "descending" ? t(_temp5) : t(_temp6)}<div className="h-full"><IcoArrowDown16 className={cx("transition-transform duration-200 ease-in-out", {
              "rotate-180": sortDirection === "descending",
              "rotate-0": sortDirection !== "descending"
            })} color={isHover ? "primary" : "tertiary"} /></div></div></button> : null}</div><div className="flex flex-col border border-solid border-primary rounded">{data_0.map((annotation_0, i) => <Fragment key={annotation_0.id}><PinnedNote annotation={annotation_0} />{i !== data_0.length - 1 && <Divider className="w-[calc(100%-32px)] m-auto" />}</Fragment>)}</div></div> : null;
};
const sortDescending = (a: {
  timestamp: string;
}, b: {
  timestamp: string;
}) => b.timestamp > a.timestamp ? 1 : -1;
const sortAscending = (a: {
  timestamp: string;
}, b: {
  timestamp: string;
}) => a.timestamp > b.timestamp ? 1 : -1;
export default PinnedNotes;
function _temp(annotation) {
  return annotation.isPinned;
}
function _temp2(data) {
  return data.filter(_temp);
}
function _temp3(prevDirection) {
  return prevDirection === "descending" ? "ascending" : "descending";
}
function _temp4($) {
  return $.title;
}
function _temp5($_0) {
  return $_0.sortDescending;
}
function _temp6($_1) {
  return $_1.sortAscending;
}